import { z, uuidSchema } from '@kc3/validation';
import { ContentTypeSchema } from '../enums/index.js';
export const ContentPermissionActionsSchema = z.object({
    canCreate: z.boolean().default(false),
    canEdit: z.boolean().default(false),
    canPublish: z.boolean().default(false),
    canUnpublish: z.boolean().default(false),
    canDelete: z.boolean().default(false),
});
export const ContentPermissionRowSchema = ContentPermissionActionsSchema.extend({
    id: uuidSchema,
    roleId: uuidSchema,
    contentType: ContentTypeSchema,
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const ContentPermissionMatrixRequestSchema = z.object({
    roleId: uuidSchema,
    permissions: z.array(ContentTypeSchema),
});
export const ContentPermissionUpdateRequestSchema = z.object({
    roleId: uuidSchema,
    contentType: ContentTypeSchema,
    permissions: ContentPermissionActionsSchema,
});
export const ContentPermissionMatrixResponseSchema = z.object({
    roleId: uuidSchema,
    roleName: z.string(),
    permissions: z.record(ContentTypeSchema, ContentPermissionActionsSchema),
});
export const ContentPermissionListResponseSchema = z.object({
    roles: z.array(ContentPermissionMatrixResponseSchema),
});
export const ContentPermissionMatrixUpdateRequestSchema = z.object({
    permissions: z.record(ContentTypeSchema, ContentPermissionActionsSchema),
});
export const ContentActivityLogSchema = z.object({
    id: uuidSchema,
    actorId: uuidSchema.nullable(),
    action: z.string(),
    articleId: uuidSchema.nullable(),
    contentType: z.string().nullable(),
    previousStatus: z.string().nullable(),
    newStatus: z.string().nullable(),
    metadata: z.record(z.string(), z.unknown()).nullable(),
    createdAt: z.string().datetime(),
});
export const ContentActivityLogQuerySchema = z.object({
    articleId: uuidSchema.optional(),
    actorId: uuidSchema.optional(),
    contentType: ContentTypeSchema.optional(),
    page: z.string().optional(),
    limit: z.string().optional(),
});
//# sourceMappingURL=content-permissions.js.map